import React, { Component } from 'react';

import CustomBraintreeUpdater from './CustomBraintreeUpdater.jsx';

export default class CustomerPaymentMethod extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="section">
        <CustomBraintreeUpdater />
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/CustomerPaymentMethod.jsx